import { Callout, EventHandler } from "client/CommonComponents";
import close from '../../../../../../assets/images/Close_SuccessPopup.svg'
import './AttachmentLink.scss';
import { CONSTANTS } from "client/utils/constants";

const AttachmentLink = (props?: any) => {
  let attachmentURL: any = [];
  if (props?.itemLevel == "Request") {
    attachmentURL = props.item?.requestAttachmentUrls
  } else if (props?.itemLevel == "Order" || props?.requesttype === CONSTANTS.AFEREQUEST) {
    attachmentURL = props.item?.orderAttachmentUrls
  }  else {
    attachmentURL = props.item?.assetAttachmentUrls
  }

  return (<>
    <div className='main-link-attachment'>
      <EventHandler onEvent={(e: any) => { props?.onLinkAttachmentClicked(props?.index, e) }} data-attribute="AttachmentLink_Default_EventHandler">
        <a
          id={`attachments${props?.index}`}
          className='link-attachment mt-3'>
          {`Attachments (${attachmentURL?.length ? attachmentURL?.length : 0})`}
        </a>
      </EventHandler>
      {props.visible && (props?.isAttachmentBtnClicked?.[props?.index] && props?.linkAttachmentId == props?.index) ?
        <Callout
          targetId={`attachments${props?.linkAttachmentId}`}
          toggleIsCalloutVisible={() => props.setVisible((prev: any) => !prev)}
          className='attachment-upload attachment-modal' data-attribute="AttachmentLink_Default_Callout">
          <div className='driverdetails-attachment-colse-btn-main clearfix'>
            <EventHandler onEvent={(e: any) => { props?.onLinkAttachmentClosed(props.index, e) }} data-attribute="AttachmentLink_Default_EventHandler_2">
              <img src={close} alt='close' className='close-btn-link' />
            </EventHandler>
          </div>
          {attachmentURL?.length ? attachmentURL?.map((url: any, index: any) => {
            const extensionList = ['jpg', 'jpeg', 'png', 'gif', 'txt', 'bmp', 'webp', 'pdf', 'docx', 'xlsx', 'heif', 'hevc'];
            const path = decodeURI(url)?.split('/');
            const fileName = path[path.length - 1]?.split('?')[0];
            const indexExt = fileName.lastIndexOf('.');
            const extension = fileName.slice(indexExt + 1);
            return (
              <div className='attachment-link' key={index}>
                {extensionList.includes(extension.toString().toLowerCase()) ?
                  <EventHandler onEvent={() => { props?.onClickAttachment(url) }} data-attribute={`AttachmentLink_${(fileName || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                    <div className='left-block'>
                      <span key={props.index} className='attachment-list'>{fileName || url}</span>
                      <div className='pull-right'></div>
                    </div>
                  </EventHandler> :
                  <div className='left-block'>
                    <a href={url}>{fileName || url}</a>
                    <div className='pull-right'></div>
                  </div>
                }
              </div>
            )
          })
            :
            <span className='tooltipBody no-content'>No Attachments Found</span>
          }
        </Callout> : ''
      }
    </div>
  </>)
}

export default AttachmentLink